module.exports = __webpack_public_path__ + "img/Home.14d0e396.svg";